import { CSSProperties } from 'react';

interface Props {
  viewBoxProp?: string;
  styleProp?: CSSProperties;
  color: string;
}

const DownloadIcon = ({ viewBoxProp, styleProp, color }: Props) => {
  const viewBox = viewBoxProp ?? "0 0 35 35";
  const style = styleProp ?? {};

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="35px" width="35px" viewBox={viewBox} style={style}>
      <g>
        <path d="M30.64,21.4c-1.1,0-2,0.9-2,2v5.05H6.36V23.4c0-1.1-0.9-2-2-2s-2,0.9-2,2v7.05c0,1.1,0.9,2,2,2h26.28
          c1.1,0,2-0.9,2-2V23.4C32.64,22.3,31.75,21.4,30.64,21.4z" fill={color} />
        <path d="M16.08,21.95c0.09,0.09,0.2,0.18,0.31,0.25c0.05,0.03,0.1,0.05,0.15,0.08c0.06,0.04,0.13,0.07,0.2,0.1
          c0.07,0.03,0.13,0.04,0.2,0.06c0.06,0.02,0.11,0.04,0.17,0.05c0.13,0.03,0.26,0.04,0.39,0.04s0.26-0.01,0.39-0.04
          c0.06-0.01,0.12-0.03,0.17-0.05c0.07-0.02,0.13-0.04,0.2-0.06c0.07-0.03,0.13-0.07,0.2-0.1c0.05-0.03,0.1-0.05,0.15-0.08
          c0.11-0.07,0.21-0.16,0.31-0.25l7.22-7.22c0.78-0.78,0.78-2.05,0-2.83s-2.05-0.78-2.83,0l-3.81,3.81V4.54c0-1.1-0.9-2-2-2
          s-2,0.9-2,2v11.17l-3.81-3.81c-0.78-0.78-2.05-0.78-2.83,0s-0.78,2.05,0,2.83L16.08,21.95z" fill={color} />
      </g>
    </svg>
  );
}

export default DownloadIcon;
